import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

//* NDBX
import {
  ButtonGroup,
  ButtonGroupIcon,
  Stack,
  Section,
  LabelTooltip,
  Link,
} from "@arp/react-ndbx";

import { SingleQuoteSummary } from "./SingleQuoteSummary.jsx";
import { CombinedQuoteSummary } from "./CombinedQuoteSummary.jsx";

//* MUI
import { Card, Typography, Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";

//* Context
import usePreQualification from "../../../hooks/usePreQualification";
// import { useCreateQuote } from "../../../hooks/dataHooks/useCreateQuote.ts";

//* Hooks
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData.js";
import useSharedData from "../../../hooks/useSharedData";

//* Utilities
import { formatCurrency } from "../../../utilities/numericFormat.js";
import { URLS } from "../../../config/const/enums.js";

export default function QuoteSummaryHeader({ ...props }) {
  // const theme = useTheme();
  const { pdsUrl } = useSharedData();
  const { onChange, isOnline } = { ...props };
  const { dataSet } = usePreQualification();
  const {
    // quoteNumber,
    // numberOfApplicants,
    // discountApplied,
    // percentageDiscountApplied,
    personOne,
    // personTwo,
  } = { ...dataSet };

  const matches = useMediaQuery("(min-width:600px)");
  const placement = matches === true ? "right" : "top";
  const showTooltip = true;
  const marginBottom = 0;
  const alignTooltip = "flex-start";

  const {
    showSecond: [showSecond],
  } = useOutletContext();

  //----------------------------------------------------------------
  const [premiumDetails, setPremiumDetails] = useState({
    frequency: "",
    amount: "",
  });

  useEffect(() => {
    setPremiumValues("monthly");
  }, []);

  const handleButtonChange = (e) => {
    setPremiumValues(e);
  };

  const setPremiumValues = (frequency) => {
    const premiumAmount = quoteInformation?.policyPremiumsTotal[frequency];

    const newValue = {
      frequency: frequency,
      amount: formatCurrency(premiumAmount),
    };
    setPremiumDetails(newValue);
    if (onChange) onChange(frequency);
  };
  //----------------------------------------------------------------

  const { isLoading, isFetching, data, error } = useGetQuote();
  const { quoteInformation, personOneQuoteInfo, personTwoQuoteInfo } = {
    ...data,
  };

  if (isLoading === true || isFetching === true) {
    return <div>Creating Quote....</div>;
  }

  return (
    <>
      {data ? (
        <Card
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#F1F9FA",
            pt: 4,
            pb: 4,
          }}
        >
          <Section mt={1}>
            <Typography variant="h2-bold">Your quote summary</Typography>
          </Section>
          <Section mt={2} sm={11} md={9} lg={6} xl={5}>
            {isOnline ? (
              <Typography variant="f1">
                This is a provisional quote only based on our standard premium
                rates for your age, smoking status, and gender.
              </Typography>
            ) : (
              <Typography variant="p2">
                Thank you for contacting us about life insurance. The premiums
                and terms quoted today are provisional only based on our
                standard premium rates for your age, smoking status and gender.
                Depending on the covers you select and what you tell us during
                your application, premiums and terms can change or cover can be
                declined.
              </Typography>
            )}
          </Section>

          {data?.numberOfApplicants === 1 ? (
            <SingleQuoteSummary
              firstName={personOne.firstName}
              frequency={premiumDetails.frequency}
              isPreQualStage={true}
              // amount={premiumDetails.amount}
              // discountApplied={discountApplied}
            />
          ) : (
            <CombinedQuoteSummary
              frequency={premiumDetails.frequency}
              // amount={premiumDetails.amount}
              // discountApplied={discountApplied}
            />
          )}
          <Section mt={2} sx={{ display: { xs: "none", sm: "initial" } }}>
            <ButtonGroup
              onChange={handleButtonChange}
              name="button-group"
              data="monthly"
              items={[
                { value: "monthly", label: "Monthly" },
                { value: "annual", label: "Yearly" },
              ]}
              sx={{
                direction: "row",
              }}
            />
          </Section>
          <Section mt={2} sx={{ display: { xs: "initial", sm: "none" } }}>
            <ButtonGroupIcon
              onChange={handleButtonChange}
              name="button-group"
              data="monthly"
              items={[
                { value: "monthly", label: "Monthly" },
                { value: "annual", label: "Yearly" },
              ]}
              sx={{
                direction: "row",
              }}
            />
          </Section>
          <Section mt={2}>
            <Link href={pdsUrl} target="_blank">
              View the PDS for more details
            </Link>
          </Section>
          <Section mt={2}>
            <Typography
              variant="p2"
              display={{ display: "inline-flex", justifyContent: "center" }}
            >
              Quote reference:{" "}
              <Typography ml={1} variant="p2-bold">
                {" "}
                {quoteInformation?.quoteNumber}
              </Typography>
            </Typography>
          </Section>
          <Section mt={2} xs={9} md={4}>
            <Typography variant="p2-bold">
              Your quote will be saved for 30 days
            </Typography>
          </Section>
          <Section sm={11} md={9} lg={6} xl={5}>
            <Typography variant="p2">
              Note that premium will increase each year based on your age.
              Premium will also increase if your Cover Amount increases, for
              example due to Inflation Proofing Increases. Premium rates and
              policy fees aren't guaranteed and may change from time to time.
            </Typography>
          </Section>
          <Section mt={2} sm={11} md={9} lg={6} xl={5}>
            <Typography variant="p2">
              If you’ve any questions about future premiums or Inflation
              Proofing Increases, contact us on{" "}
              <Link href={URLS.CONTACT_US_PHONE_URL}>
                {URLS.CONTACT_US_PHONE_NUMBER}
              </Link>
              .
            </Typography>
          </Section>
        </Card>
      ) : null}{" "}
    </>
  );
}
